import { DlGroupService } from "@/services/dlgroup.service";

const state = {
  dlGroupName: null,
  logoUrl: null,
  phoneNumber: null,
  address: {
    street: null,
    zip: null,
    city: null
  },
  infoPages: []
};

const actions = {
  async getConfig({ commit }) {
    await DlGroupService.getMetaInfo().then(res => {
      commit("setDlGroupName", res.data.name);
      commit("setLogoUrl", res.data.logo);
      commit("setPhoneNumber", res.data.tel);
      commit("setAddress", {
        street: res.data.strasse,
        zip: res.data.plz,
        city: res.data.ort
      });
    });

    await DlGroupService.getInfoPage().then(infoPages => {
      commit("setInfoPages", infoPages);
    });
  },
  getInfoPage({ commit }, language) {
    DlGroupService.getInfoPage(language).then(infoPages => {
      commit("setInfoPages", infoPages);
    });
  }
};

const mutations = {
  setDlGroupName(state, dlGroupName) {
    state.dlGroupName = dlGroupName;
  },
  setLogoUrl(state, logoUrl) {
    state.logoUrl = logoUrl;
  },
  setPhoneNumber(state, phoneNUmber) {
    state.phoneNumber = phoneNUmber;
  },
  setAddress(state, address) {
    state.address = address;
  },
  setInfoPages(state, infoPages) {
    state.infoPages = infoPages;
  }
};

const getters = {
  getDlGroupName(state) {
    return state.dlGroupName;
  },
  getLogoUrl(state) {
    return state.logoUrl;
  },
  getPhoneNumber(state) {
    return state.phoneNumber;
  },
  getAddress(state) {
    return state.address;
  },
  getOrderedInfoPage(state) {
    return []; //state.infoPages.sort((a, b) => (a.position > b.position ? 1 : -1));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
